export const translations = {
  sk: {
    appTitle: 'FODMAP Aplikácia',
    searchPlaceholder: 'Hľadať...',
    loading: 'Načítavam FODMAP údaje...',
    error: 'Chyba pri načítaní FODMAP údajov:',
    showingResults: 'Zobrazených',
    foodsText: 'FODMAP potravín',
    category: 'Kategória:',
    darkMode: 'Tmavý režim',
    lightMode: 'Svetlý režim',
    language: 'Jazyk'
  },
  en: {
    appTitle: 'FODMAP App',
    searchPlaceholder: 'Search...',
    loading: 'Loading FODMAP data...',
    error: 'Error loading FODMAP data:',
    showingResults: 'Showing',
    foodsText: 'FODMAP foods',
    category: 'Category:',
    darkMode: 'Dark mode',
    lightMode: 'Light mode',
    language: 'Language'
  }
};

// Category translations
export const categoryTranslations = {
  sk: {
    'Breads, Cereals, Grains and Pasta': 'Chlieb, Cereálie, Obilie a Cestoviny',
    'Vegetables and legumes': 'Zelenina a Strukoviny',
    'Cooking ingredients, Herbs and Spices': 'Varenie, Bylinky a Korenie',
    'Fruit': 'Ovocie',
    'Condiments': 'Dresiny a Omáčky',
    'Drinks': 'Nápoje',
    'Meat & Substitutes': 'Mäso a Náhradky',
    'Nuts and Seeds': 'Orechy a Semená',
    'Sweeteners': 'Sladidlá',
    'Milk': 'Mlieko',
    'Dairy': 'Mliečne Výrobky',
    'Cheese': 'Syr',
    'Low FODMAP Certified Foods': 'Certifikované potraviny s nízkym FODMAP',
    'Low FODMAP Certified Meals': 'Certifikované jedlá s nízkym FODMAP',
  'Bread, Cereals, Rice, Pasta': 'Chlieb, Cereálie, Ryža, Cestoviny',
  'Bread, Cereals, Flours, Grains': 'Chlieb, Cereálie, Múky, Obilniny',
  'Vegetables image': 'Zelenina obrázok',
  'Vegetables': 'Zelenina',
  'Fresh & Processed Vegetables': 'Čerstvá a Spracovaná Zelenina',
  'Fruit image': 'Ovocie obrázok',
  'Fresh & Processed Fruit': 'Čerstvé a Spracované Ovocie',
  'Dairy, Soy & Lactose Free image': 'Mliečne, Sójové a Bezlaktózové obrázok',
  'Dairy, Soy & Lactose Free': 'Mliečne, Sójové a Bezlaktózové',
  'Milk, Cheese & Plant Alternatives': 'Mlieko, Syr a Rastlinné Alternatívy',
  'Pulses, Tofu, Nuts image': 'Strukoviny, Tofu, Orechy obrázok',
  'Pulses, Tofu, Nuts': 'Strukoviny, Tofu, Orechy',
  'Nuts, Seeds, Pulses & Vegetarian': 'Orechy, Semená, Strukoviny a Vegetariánske',
  'Beverages image': 'Nápoje obrázok',
  'Beverages': 'Nápoje',
  'Juice, Tea, Coffee, Alcohol & Powders': 'Džúsy, Čaje, Káva, Alkohol a Prášky',
  'Meat, Fish, Eggs image': 'Mäso, Ryby, Vajcia obrázok',
  'Meat, Fish, Eggs': 'Mäso, Ryby, Vajcia',
  'Meat & Prepared dishes': 'Mäso a Pripravené Jedlá',
  'Fats & Oils image': 'Tuky a Oleje obrázok',
  'Fats & Oils': 'Tuky a Oleje',
  'Edible Fats & Oil': 'Jedlé Tuky a Oleje',
  'Condiments image': 'Dresingy obrázok',
  'Dips, Herbs, Sauces, Spices & Spreads': 'Nátierky, Bylinky, Omáčky, Koreniny a Pomazánky',
  'Snacks, Bars & Cookies image': 'Snacky, Tyčinky a Sušienky obrázok',
  'Snacks, Bars & Cookies': 'Snacky, Tyčinky a Sušienky',
  'Bars, Biscuits & Cookies': 'Tyčinky, Sušienky a Keksíky',
  'Confectionery & Sugars image': 'Cukrovinky a Cukry obrázok',
  'Confectionery & Sugars': 'Cukrovinky a Cukry',
  'Confectionery, Syrup & Sugars': 'Cukrovinky, Sirupy a Cukry',
  'Dietary Supplements image': 'Výživové Doplnky obrázok',
  'Dietary Supplements': 'Výživové Doplnky',
  'Drinks / Fibers / Powders / Capsules': 'Nápoje / Vláknina / Prášky / Kapsuly'
  },
  en: {
    'Breads, Cereals, Grains and Pasta': 'Breads, Cereals, Grains and Pasta',
    'Vegetables and legumes': 'Vegetables and Legumes',
    'Cooking ingredients, Herbs and Spices': 'Cooking Ingredients, Herbs and Spices',
    'Fruit': 'Fruit',
    'Condiments': 'Condiments',
    'Drinks': 'Drinks',
    'Meat & Substitutes': 'Meat & Substitutes',
    'Nuts and Seeds': 'Nuts and Seeds',
    'Sweeteners': 'Sweeteners',
    'Milk': 'Milk',
    'Dairy': 'Dairy',
    'Cheese': 'Cheese',
    'Low FODMAP Certified Foods': 'Low FODMAP Certified Foods',
    'Low FODMAP Certified Meals': 'Low FODMAP Certified Meals',
  'Bread, Cereals, Rice, Pasta': 'Bread, Cereals, Rice, Pasta',
  'Bread, Cereals, Flours, Grains': 'Bread, Cereals, Flours, Grains',
  'Vegetables image': 'Vegetables image',
  'Vegetables': 'Vegetables',
  'Fresh & Processed Vegetables': 'Fresh & Processed Vegetables',
  'Fruit image': 'Fruit image',
  'Fresh & Processed Fruit': 'Fresh & Processed Fruit',
  'Dairy, Soy & Lactose Free image': 'Dairy, Soy & Lactose Free image',
  'Dairy, Soy & Lactose Free': 'Dairy, Soy & Lactose Free',
  'Milk, Cheese & Plant Alternatives': 'Milk, Cheese & Plant Alternatives',
  'Pulses, Tofu, Nuts image': 'Pulses, Tofu, Nuts image',
  'Pulses, Tofu, Nuts': 'Pulses, Tofu, Nuts',
  'Nuts, Seeds, Pulses & Vegetarian': 'Nuts, Seeds, Pulses & Vegetarian',
  'Beverages image': 'Beverages image',
  'Beverages': 'Beverages',
  'Juice, Tea, Coffee, Alcohol & Powders': 'Juice, Tea, Coffee, Alcohol & Powders',
  'Meat, Fish, Eggs image': 'Meat, Fish, Eggs image',
  'Meat, Fish, Eggs': 'Meat, Fish, Eggs',
  'Meat & Prepared dishes': 'Meat & Prepared dishes',
  'Fats & Oils image': 'Fats & Oils image',
  'Fats & Oils': 'Fats & Oils',
  'Edible Fats & Oil': 'Edible Fats & Oil',
  'Condiments image': 'Condiments image',
  'Dips, Herbs, Sauces, Spices & Spreads': 'Dips, Herbs, Sauces, Spices & Spreads',
  'Snacks, Bars & Cookies image': 'Snacks, Bars & Cookies image',
  'Snacks, Bars & Cookies': 'Snacks, Bars & Cookies',
  'Bars, Biscuits & Cookies': 'Bars, Biscuits & Cookies',
  'Confectionery & Sugars image': 'Confectionery & Sugars image',
  'Confectionery & Sugars': 'Confectionery & Sugars',
  'Confectionery, Syrup & Sugars': 'Confectionery, Syrup & Sugars',
  'Dietary Supplements image': 'Dietary Supplements image',
  'Dietary Supplements': 'Dietary Supplements',
  'Drinks / Fibers / Powders / Capsules': 'Drinks / Fibers / Powders / Capsules'
  }
};

// Helper function to get translated category
export const getTranslatedCategory = (category, language) => {
  return categoryTranslations[language]?.[category] || category;
};
